'use client'

import { faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import { useTranslations } from 'next-intl'
import { useCachedUnitObjectivesSWR } from '~/app/actions/progress'
import OverviewStatusChip from '~/components/progress/OverviewStatusChip'
import { SupportedLocales } from '~/types'

export default function UnitObjectiveProgress({
  courseId,
  moduleId,
  unitId,
  locale,
}: {
  courseId: string | number
  moduleId: string | number
  unitId: string | number
  locale: SupportedLocales
}) {
  const t = useTranslations()
  const { data } = useCachedUnitObjectivesSWR({
    courseId,
    moduleId,
    unitId,
    locale,
  })

  if (!data || data.availableObjs === 0) {
    return null
  }

  return (
    <OverviewStatusChip
      icon={faCheckDouble}
      kind="objective"
      completed={data.completedObjs}
      total={data.availableObjs}
      label={t('generic.nCompletedObjectives', {
        completed: data.completedObjs,
        available: data.availableObjs,
      })}
    />
  )
}
